<h4 class="mt-4">Sökparametrar</h4>
<div class="parameter-grid">
  <div>
    <div>Smittämne</div>
    <div class="fw-bold">
      @if (!searchParams.smittamne || searchParams.smittamne.length === 0) {
        Alla
      } @else if (searchParams.smittamne.length > 1) {
        <button popovertarget="smittamne-popover" class="popover-button">
          <i class="fas fa-info-circle smittamne-anchor"></i>
        </button>
        Flera
      } @else {
        {{ searchParams.smittamne[0] }}
      }
    </div>
  </div>
  <div>
    <div>Provtagningsår</div>
    <div class="fw-bold">{{ searchParams.fullYear }}</div>
  </div>
  @if (searchParams.sampleDateStart && searchParams.sampleDateEnd) {
    <div>
      <div>Provtagningsdatum</div>
      <div class="fw-bold">{{ searchParams.sampleDateStart + " till " + searchParams.sampleDateEnd }}</div>
    </div>
  }
  <div>
    <div>Analys</div>
    <div class="fw-bold">
      @if (!searchParams.analys || searchParams.analys.length === 0) {
        Alla
      } @else if (searchParams.analys.length > 1) {
        <button popovertarget="analys-popover" class="popover-button">
          <i class="fas fa-info-circle analys-anchor"></i>
        </button>
        Flera
      } @else {
        {{ searchParams.analys[0] }}
      }
    </div>
  </div>
  <div>
    <div>Provmaterial</div>
    <div class="fw-bold">
      @if (!searchParams.provMaterial || searchParams.provMaterial.length === 0) {
        Alla
      } @else if (searchParams.provMaterial.length > 1) {
        <button popovertarget="provmaterial-popover" class="popover-button">
          <i class="fas fa-info-circle provmaterial-anchor"></i>
        </button>
        Flera
      } @else {
        {{ searchParams.provMaterial[0] }}
      }
    </div>
  </div>
  <div>
    <div>Laboratorium</div>
    <div class="fw-bold">
      @if (!searchParams.labb || searchParams.labb.length === 0) {
        Alla
      } @else if (searchParams.labb.length > 1) {
        <button popovertarget="labb-popover" class="popover-button">
          <i class="fas fa-info-circle labb-anchor"></i>
        </button>
        Flera
      } @else {
        {{ searchParams.labb[0] }}
      }
    </div>
  </div>
  <div>
    <div>Åldersgruppsindelning enligt</div>
    <div class="fw-bold">{{ searchParams.ageIntervalStandard ?? "Ingen indelning vald" }}</div>
  </div>
  <div>
    <div>Åldersintervall</div>
    <div class="fw-bold">{{ searchParams.ageSpan ? searchParams.ageSpan.join(" - ") : "Alla" }}</div>
  </div>

  <div>
    <div>Kön</div>
    <div class="fw-bold">
      @if (!searchParams.gender || searchParams.gender.length === 0) {
        Alla
      } @else {
        {{ getGenderText(searchParams.gender) }}
      }
    </div>
  </div>
 <div>
    <div *ngIf="searchParams.searchType === searchTypes.GENERAL">
      <div>Antibiotika</div>
      <div class="fw-bold">
        @if (!searchParams.antibiotics || searchParams.antibiotics.length === 0) {
          Alla
        } @else if (searchParams.antibiotics.length > 1) {
          <button popovertarget="antibiotics-popover" class="popover-button">
            <i class="fas fa-info-circle antibiotics-anchor"></i>
          </button>
          Flera
        } @else {
          {{ searchParams.antibiotics[0] }}
        }
      </div>
    </div>
  </div>

  <div popover id="smittamne-popover" class="popover-common">
    @for (item of searchParams.smittamne; track $index) {
      <p>{{ item }}</p>
    }
  </div>
  <div popover id="analys-popover" class="popover-common">
    @for (item of searchParams.analys; track $index) {
      <p>{{ item }}</p>
    }
  </div>
  <div popover id="provmaterial-popover" class="popover-common">
    @for (item of searchParams.provMaterial; track $index) {
      <p>{{ item }}</p>
    }
  </div>
  <div popover id="labb-popover" class="popover-common">
    @for (item of searchParams.labb; track $index) {
      <p>{{ item }}</p>
    }
  </div>
</div>
